<template>
  <div :class="$route.path.includes('admin') ? '' : 'col-lg-12'">
    <admin-center-header
      v-if="$can('manage_dermicus') && $route.path.includes('admin')"
      :active-section="1"
      :selected-menu-item="3"
    />
    <center-header v-else selected-menu-item="3" />
    <div class="tab-content">
      <div class="text-right mb-2">
        <router-link
          :to="{
            name: `New${getCenterGroupUrlAndComponentPart.adminType}CenterGroup`,
          }"
          class="btn btn-primary"
          data-test="group-add-btn"
        >
          {{ trans("center.addNewGroupBtn") }}
        </router-link>
      </div>

      <div class="table-responsive">
        <table class="table table-hover interactive-table">
          <thead class="sortable-table-header">
            <tr>
              <th>{{ trans("center.groupTableGroupName") }}</th>
              <th>{{ trans("center.groupTableConnectedUsers") }}</th>
            </tr>
          </thead>
          <tbody v-if="!loading">
            <tr
              v-for="(group, index) in groups"
              :key="index"
              data-test="group-admin-list-row"
              :data-group-id="group.id"
              @click="openGroup(group)"
            >
              <td data-test="group-admin-list-name">{{ group.name }}</td>
              <td data-test="group-admin-list-users-count">
                {{ group.totalUsers }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <clip-loader v-if="loading" />

      <div class="row-fluid float-right">
        <DerPaginate
          v-model="paginate.current_page"
          :page-count="paginate.last_page"
          @change="getGroups"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CenterHeader from "../CenterHeader.vue";
import DerPaginate from "../../../design-system/DerPaginate.vue";
import AdminCenterHeader from "../../Admin/Centers/AdminCenterHeader.vue";
import { getCenterGroupUrlAndComponentPart } from "../../Utils/getCenterGroupUrlAndComponentPart";

export default {
  components: {
    AdminCenterHeader,
    CenterHeader,
    DerPaginate,
  },
  data() {
    return {
      loading: false,
      groups: [],
      paginate: {
        current_page: 0,
        last_page: 0,
      },
    };
  },
  computed: {
    getCenterGroupUrlAndComponentPart: function () {
      return getCenterGroupUrlAndComponentPart(
        this.$can,
        this.$route,
        this.$store,
      );
    },
  },
  created: function () {
    this.getGroups();
  },
  methods: {
    getGroups(page) {
      this.loading = true;

      axios
        .get(this.getCenterGroupUrlAndComponentPart.url, { params: { page } })
        .then((data) => {
          let collection = data.data;
          this.paginate = collection.paginate;
          this.groups = collection.data;
          this.loading = false;
        })
        .catch((error) => {
          this.userErrorMessage(error);
          this.loading = false;
        });
    },
    openGroup: function (group) {
      this.$router.push({
        name: `Edit${this.getCenterGroupUrlAndComponentPart.adminType}CenterGroup`,
        params: {
          groupId: group.id,
          id: this.getCenterGroupUrlAndComponentPart.centerId,
        },
      });
    },
  },
};
</script>
